import React from "react";
import ShareCompaniesForm from "../../../components/ShareCompaniesForm";
import { reloadTable } from "../../../components/SmartTable/reducer";
import { TABLE_TRG_TRAININGS } from "./methods";

export const MODAL_SHARE_TRAINING = "MODAL_SHARE_TRAINING";

const ShareTrainingForm = () => (
  <ShareCompaniesForm
    modalName={MODAL_SHARE_TRAINING}
    apiRoute="trg/shared-trainings"
    idKey="training_id"
    titleKey="trg.share_training"
    descriptionKey="trg.share_training_description"
    onSuccessAction={(dispatch) => dispatch(reloadTable({ name: TABLE_TRG_TRAININGS }))}
  />
);

export default ShareTrainingForm;
